/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/sort-comp */
import React from 'react';

import {connect} from 'react-redux';

import * as loadingActions from '@/actions/loadingActions';
import {Post, Get} from '@/api/request';
import * as APPDATA from '@/constants/pcConstAppData';
import {eventBusObject} from '@/observers/eventBus';

const MAX_MULTIPLE_REQ_THRESH = 15;
@connect((store) => {
  const {currentAdvSetupParams, autoProfileSetupMode} = store.setupStore;

  return {
    highVolumeBuffer:
      currentAdvSetupParams[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.GeneralAdvSetup][
        APPDATA.KEY.HighVolumeBufferFlag
      ] || false,
    autoProfileSetupMode,
  };
})
class TubeAvailabilityCheck extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    this._bus = eventBusObject();
    this._multipleReqCounter = 0;
    this._isTubeAvailabilityCancled = false;
    this.successResetVolumeMonitoring = this.successResetVolumeMonitoring.bind(this);
    this.successGetTubeExist = this.successGetTubeExist.bind(this);
  }

  clearLoopTubeExist = () => {
    if (this._getTubeExist === undefined) return;
    clearInterval(this._getTubeExist);
    this._getTubeExist = undefined;
  };

  componentDidMount() {
    this.eventTubeAvailability = this._bus.subscribe(TubeAvailabilityCheckEvent.TUBE_AVAILABILITY, (param) =>
      this.tubeAvailabilityCheck(param),
    );
  }

  componentWillUnmount() {
    this.eventTubeAvailability.unsubscribe();
    this.clearLoopTubeExist();
  }

  updateMessageLoading = (props) => {
    this.props.dispatch(
      loadingActions.updateLoading({
        showLoading: props.showLoading,
        loadingText: props.loadingText,
        loadingButton1:
          props.loadingButton1 !== undefined
            ? {
                label: props.loadingButton1.label,
                onClick: props.loadingButton1.onClick,
              }
            : undefined,
      }),
    );
  };

  closeLoading = () => {
    const propsTubeAvailabilityCheck = {
      showLoading: undefined,
      loadingText: undefined,
      loadingButton1: undefined,
    };
    this.updateMessageLoading(propsTubeAvailabilityCheck);
  };

  // TubeAvailabilityCheck
  tubeAvailabilityCheck = () => {
    this._isTubeAvailabilityCancled = false;
    const propsTubeAvailabilityCheck = {
      showLoading: true,
      loadingText: APPDATA.MESSAGES.TUBE_AVAILABILITY_CHECK.CHECK_SYSTEM,
      loadingButton1: {
        label: APPDATA.CANCEL,
        onClick: this.cancleResetVolumeMonitoring,
      },
    };
    this.updateMessageLoading(propsTubeAvailabilityCheck);

    this.getTubeExist(GetTubeExistType.SINGLE);
  };

  getTubeExist = (RequestTypeParam) => {
    if (this._getTubeExist) {
      this.clearLoopTubeExist();
    }
    this._getTubeExist = setInterval(() => {
      if (this._isTubeAvailabilityCancled === true) {
        this.clearLoopTubeExist();
        return;
      }
      const param = {};
      const passingParam = {
        RequestType: RequestTypeParam,
      };
      Get(APPDATA.API.GET_TUBE_EXIST, param, this.successGetTubeExist, passingParam);
    }, APPDATA.CONFIGURATION.INTERVAL.STATUS_TIME_UPDATE);
  };

  successGetTubeExist = (response, passingParam) => {
    const {highVolumeBuffer, autoProfileSetupMode} = this.props;
    if (this._isTubeAvailabilityCancled === true) {
      this.clearLoopTubeExist();
      return;
    }
    const isProteinTubeAvailable = response.data[APPDATA.KEY.ProteinTube];
    const isBufferTubeAvailable = response.data[APPDATA.KEY.BufferTube];
    const isHiVolBufferExchange =
      highVolumeBuffer && autoProfileSetupMode === APPDATA.AUTO_PROFILE_STATE.BUFFER_EXCHANGE;

    switch (passingParam.RequestType) {
      case GetTubeExistType.SINGLE:
        if (isHiVolBufferExchange && isProteinTubeAvailable === false) {
          const propsTubeAvailabilityCheck = {
            showLoading: true,
            loadingText: APPDATA.MESSAGES.TUBE_AVAILABILITY_CHECK.SAMPLE_TUBE_NOT_DETECTED,
            loadingButton1: {
              label: APPDATA.CONFIRM,
              onClick: this.actionConfirmAfterRemoveTube,
            },
          };
          this.updateMessageLoading(propsTubeAvailabilityCheck);
        } else if (!isHiVolBufferExchange && (isBufferTubeAvailable === false || isProteinTubeAvailable === false)) {
          const propsTubeAvailabilityCheck = {
            showLoading: true,
            loadingText: APPDATA.MESSAGES.TUBE_AVAILABILITY_CHECK.TUBE_NOT_DETECTED,
            loadingButton1: {
              label: APPDATA.CONFIRM,
              onClick: this.actionConfirmAfterRemoveTube,
            },
          };
          this.updateMessageLoading(propsTubeAvailabilityCheck);
        } else {
          this.actionTubeDetected();
        }
        this.clearLoopTubeExist();
        break;
      case GetTubeExistType.MULTIPLE:
        if (isBufferTubeAvailable === true && isProteinTubeAvailable === true) {
          this.actionTubeDetected();
          this.clearLoopTubeExist();
        } else {
          const multipleReqCounter = this._multipleReqCounter + 1;
          if (multipleReqCounter > MAX_MULTIPLE_REQ_THRESH) {
            this.clearLoopTubeExist();
            this.getTubeExist(GetTubeExistType.SINGLE);
            this._multipleReqCounter = 0;
          } else {
            this._multipleReqCounter = multipleReqCounter;
          }
        }
        break;
      default:
        break;
    }
  };

  actionConfirmAfterRemoveTube = () => {
    const propsTubeAvailabilityCheck = {
      showLoading: true,
      loadingText: APPDATA.MESSAGES.TUBE_AVAILABILITY_CHECK.KEEP_TUBE_NOT_INSERTED,
      loadingButton1: {
        label: APPDATA.CANCEL,
        onClick: this.cancleResetVolumeMonitoring,
      },
    };
    this.updateMessageLoading(propsTubeAvailabilityCheck);

    // delay to waiting backend state changes
    setTimeout(() => {
      if (this._isTubeAvailabilityCancled === false) this.resetVolumeMonitoring();
    }, 5000);
  };

  resetVolumeMonitoring = () => {
    const propsTubeAvailabilityCheck = {
      showLoading: true,
      loadingText: APPDATA.MESSAGES.TUBE_AVAILABILITY_CHECK.KEEP_TUBE_NOT_INSERTED,
      loadingButton1: {
        label: APPDATA.CANCEL,
        onClick: this.cancleResetVolumeMonitoring,
      },
    };
    this.updateMessageLoading(propsTubeAvailabilityCheck);

    const param = {};
    Post(APPDATA.API.RESET_VOLUME_MONITORING, param, this.successResetVolumeMonitoring);
  };

  cancleResetVolumeMonitoring = () => {
    this.closeLoading();
    this.clearLoopTubeExist();
    this._isTubeAvailabilityCancled = true;
  };

  successResetVolumeMonitoring = () => {
    if (this._isTubeAvailabilityCancled === true) return;
    const propsTubeAvailabilityCheck = {
      showLoading: true,
      loadingText: APPDATA.MESSAGES.TUBE_AVAILABILITY_CHECK.WAITING_TUBE,
      loadingButton1: {
        label: APPDATA.CANCEL,
        onClick: () => {
          this.clearLoopTubeExist();
          this.closeLoading();
          this._multipleReqCounter = 0;
          this._isTubeAvailabilityCancled = true;
        },
      },
    };
    this.updateMessageLoading(propsTubeAvailabilityCheck);

    this.actionFinishResetVolumeMonitoring();
  };

  actionFinishResetVolumeMonitoring = () => {
    setTimeout(() => {
      if (this._isTubeAvailabilityCancled === false) {
        this.getTubeExist(GetTubeExistType.MULTIPLE);
        this.props.setRecheckAvailability(true);
      }
    }, 5000);
  };

  actionTubeDetected = () => {
    const {highVolumeBuffer, autoProfileSetupMode} = this.props;
    const propsTubeAvailabilityCheck = {
      showLoading: true,
      loadingText:
        highVolumeBuffer && autoProfileSetupMode === APPDATA.AUTO_PROFILE_STATE.BUFFER_EXCHANGE
          ? APPDATA.MESSAGES.TUBE_AVAILABILITY_CHECK.SAMPLE_TUBE_DETECTED
          : APPDATA.MESSAGES.TUBE_AVAILABILITY_CHECK.TUBE_DETECTED,
      loadingButton1: {
        label: APPDATA.CANCEL,
        onClick: this.cancleResetVolumeMonitoring,
      },
    };
    this.updateMessageLoading(propsTubeAvailabilityCheck);

    this._multipleReqCounter = 0;

    setTimeout(() => {
      if (this._isTubeAvailabilityCancled === false) this.props.callbackTubeAvailable();

      this.clearLoopTubeExist();
    }, 3000);
  };

  render() {
    return null;
  }
}

export default TubeAvailabilityCheck;

export const TubeAvailabilityCheckEvent = {
  TUBE_AVAILABILITY: 'TUBE_AVAILABILITY',
};

export const GetTubeExistType = {
  SINGLE: 'SINGLE',
  MULTIPLE: 'MULTIPLE',
};
